<!-- 实现标签点击显示不同内容 -->

<template>
  <div class="show">
    <!-- 标题 -->
    <div style="text-align: center">
      <span style="background-color: rgb(56, 68, 118);
        display: block;
        height: 3px;
        margin: 0 auto 12px auto;
        width: 60px;
        
        "></span>
      <h3 class="abountTitle">关于我们</h3>
    </div>

    <div class="show">
      <a href="#about" style="text-decoration: none;color: inherit;">
      <div style="height: 450px;">
        <transition name="fade">
          <!-- 里程碑轮播 -->
          <div style="position: relative;height: 400px;   padding-bottom: 50px;"  v-if="0 === number">
            <!-- <img
              src="../assets/companyBG.jpg"
            /> -->
            <milestone></milestone>
            
          </div>
        </transition>

        <!-- 荣誉卡片切换 -->
        <transition name="fade">
          <div class="right3" v-if="1 === number">
            <el-carousel :interval="400000" type="card" class="number_1">
              <el-carousel-item v-for="item in list" :key="item.id">
                <!-- <h3 class="medium">{{ item }}</h3> -->
                <img :src="item.url" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </transition>
        <!-- 合作伙伴展示 -->
        <transition name="fade">
          <div class="right3" v-if="2 === number">
            <!-- <img
              src="../assets/footer-bg4.jpg"
            /> -->
            <Co></Co>
          </div>
        </transition>
      </div>

      <!-- 按钮 -->
      <div class="right1">
        <span
          class="btn_anniu"
          @click="change(0)"
          :class="{ newStyle: 0 === number }"
          >里程碑</span
        >
        <span
          class="btn_anniu"
          @click="change(1)"
          :class="{ newStyle: 1 === number }"
          >荣誉</span
        >
        <span
          class="btn_anniu"
          @click="change(2)"
          :class="{ newStyle: 2 === number }"
          >合作伙伴</span
        >
      </div>
    </a>
    </div>
  </div>
</template>

<script>
import milestone from './milestone.vue'
import company from '../assets/companyBG.jpg'
import footerBg1 from '../assets/footer-bg1.jpg'
import footerBg2 from '../assets/footer-bg2.jpg'
import footerBg3 from '../assets/footer-bg3.jpg'
import footerBg4 from '../assets/footer-bg4.jpg'
import Co from './co.vue'
import {getHonor} from '../utils/api.js'

export default {
  name: "about",
  data() {
    return {
      number: 0,
      list: [
        // {
        //   id: 0,
        //   name: "荣誉1",
        //   picLink:
        //     footerBg1,
        // },
        // {
        //   id: 1,
        //   name: "荣誉2",
        //   picLink:
        //     footerBg2,
        // },
        // {
        //   id: 2,
        //   name: "荣誉3",
        //   picLink:
        //     footerBg3,
        // },
        // {
        //   id: 3,
        //   name: "荣誉4",
        //   picLink:
        //     footerBg4,
        // },
      ],
    };
  },
  components: { milestone, Co },
  created(){
    this.load()
  },

  methods: {
    load(){
            getHonor().then(res =>{
                // console.log(res)
                this.list = res.data
            })
        },
    change(index) {
      if(this.number == index){
          return
      }
      this.number = 4; //重要处
      setTimeout(() => {
        this.number = index; //重要处
      }, 480);
    },
  },
};
</script>

<style>
.abountTitle {
  color: #ccc;
  padding: 0px 30px 30px;
  font-size: 30px;
  font-weight: bold;
}
.aboutContent {
  color: #7f7f7f;
  letter-spacing: 2px;
  line-height: 25px;
  text-align: center;
  padding: 20px;
  width: 500px;
  margin: 0 auto; /* Center align the div */
}

.newStyle {
  border-bottom: 3px solid #384476 ;
  
  /* color: #f0892e; */
  /* font-size: 29px; */
  font-weight: bold;
}

.right3 {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  padding-bottom: 50px;
  height: 400px;
}
.right3 img {
  float: left;
  /* margin-right: 10px; */
  width: 100%;
  height: 100%;
}
.right3 p {
  /* width: 500px;
  height: 500px; */
  line-height: 20px;
  overflow: hidden;
}

.right1 {
  /* height: 50px; */
  display: flex;
  display: flex;
  justify-content: center;
  padding-top: 20px;

}
.right1 span {
  cursor: pointer;
  padding: 15px;

}

/* 荣誉卡片切换 */
.number_1 {
  /*修改宽高,提高优先级*/
  height: 400px !important;
  width: 1000px !important;
}
/* 隐藏指示灯 */
.number_1 .el-carousel__indicator {
  display: none;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/* 内容动画淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.el-carousel__item--card {
    width: calc(50% - 40px) !important;
    height: calc(100% - 40px) !important;
    transition: transform .4s ease-in-out !important;
    padding: 20px !important;
}
</style>
